function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("title", null, "dots");
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  id: "Desktop-view",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-Home-screen---Messages",
  transform: "translate(-512.000000, -365.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M513.749996,367.906269 C514.114578,367.906269 514.424474,367.778665 514.679681,367.523458 C514.934889,367.26825 515.062493,366.958355 515.062493,366.593772 C515.062493,366.22919 514.934889,365.919295 514.679681,365.664087 C514.424474,365.40888 514.114578,365.281276 513.749996,365.281276 C513.385414,365.281276 513.075518,365.40888 512.820311,365.664087 C512.565103,365.919295 512.437499,366.22919 512.437499,366.593772 C512.437499,366.958355 512.565103,367.26825 512.820311,367.523458 C513.075518,367.778665 513.385414,367.906269 513.749996,367.906269 Z M513.749996,372.062509 C514.114578,372.062509 514.424474,371.934905 514.679681,371.679698 C514.934889,371.42449 515.062493,371.114595 515.062493,370.750013 C515.062493,370.38543 514.934889,370.075535 514.679681,369.820327 C514.424474,369.56512 514.114578,369.437516 513.749996,369.437516 C513.385414,369.437516 513.075518,369.56512 512.820311,369.820327 C512.565103,370.075535 512.437499,370.38543 512.437499,370.750013 C512.437499,371.114595 512.565103,371.42449 512.820311,371.679698 C513.075518,371.934905 513.385414,372.062509 513.749996,372.062509 Z M513.749996,376.218749 C514.114578,376.218749 514.424474,376.091145 514.679681,375.835938 C514.934889,375.58073 515.062493,375.270835 515.062493,374.906253 C515.062493,374.54167 514.934889,374.231775 514.679681,373.976567 C514.424474,373.72136 514.114578,373.593756 513.749996,373.593756 C513.385414,373.593756 513.075518,373.72136 512.820311,373.976567 C512.565103,374.231775 512.437499,374.54167 512.437499,374.906253 C512.437499,375.270835 512.565103,375.58073 512.820311,375.835938 C513.075518,376.091145 513.385414,376.218749 513.749996,376.218749 Z",
  id: "dots"
})));
const Svg3Dots = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4px",
    height: "12px",
    viewBox: "0 0 4 12",
    ref: svgRef
  }, props), _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg3Dots, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/3-dots.bd61e6ef.svg";
export { ForwardRef as ReactComponent };